export default {"src":"/_next/static/media/cicon3.be99a484.svg","height":56,"width":51};